export const getAddRoleJson = (data) => {
  const AddRoleForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          [
            {
              id: 1,
              label: "Role Name",
              type: "text",
              name: "rolename",
              Placeholder: "Role Name",
              value: data["rolename"],
              validationRules: [
                {
                  required: true,
                  message: `Please enter your Role Name`,
                },
              ],
            },
          ],
          [
            {
              id: 2,
              label: "Next",
              type: "button",
              position: "end",
              textColor: "white",
              event: "submit",
            },
            // {
            //   id: 2,
            //   label: "Reset",
            //   type: "button",
            //   position: "end",
            //   textColor: "white",
            //   event: "submit",
            // },
          ],
        ],
      },
    ],
  };

  return {
    AddRoleForm,
  };
};
